import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
import SearchPopup from './SearchPopup';
import navImg from "../../../assets/images/resources/tt-logo.png";

const HeaderStyleTwo = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileMenu, setMobileMenu] = useState(false);
    const [isPopup, setIsPopup] = useState(false);

    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        if (!isMobileMenu) {
            document.body.classList.add("mobile-menu-visible");
        } else {
            document.body.classList.remove("mobile-menu-visible");
        }
    }

    const handlePopup = () => {
        setIsPopup(!isPopup);
    }


    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <React.Fragment>
            <header className={`main-header-two ${isVisible ? "fixed-header" : ""}`}>
                <div className="main-menu-two__top">
                    <div className="container">
                        <div className="main-menu-two__top-inner">
                            <ul className="list-unstyled main-menu-two__contact-list">
                                {/* <li>
                                    <div className="icon">
                                        <i className="icon-call"></i>
                                    </div>
                                    <div className="text">
                                        <p>
                                            <Link to="tel:+91 80969 62555">+91 80969 62555</Link>
                                        </p>
                                    </div>
                                </li> */}
                                <li>
                                    <div className="icon">
                                        <i className="icon-envelope"></i>
                                    </div>
                                    <div className="text">
                                        <p>
                                            <Link to=" Info@techtotalers.in"> Info@techtotalers.in</Link>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <div className="main-menu-two__top-right">
                                <div className="main-menu-two__social">
                                    {/* <Link to="#"><i className="icon-instagram"></i></Link> */}
                                    <Link to="https://www.linkedin.com/in/techtotalers-private-limited-020b0a248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><i className="icon-linkedin-in"></i></Link>
                                    {/* <Link to="#"><i className="icon-Vector"></i></Link>
                                    <Link to="#"><i className="icon-facebook-f"></i></Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <nav className="main-menu main-menu-two">
                    <div className="main-menu-two__wrapper">
                        <div className="container">
                            <div className="main-menu-two__wrapper-inner">
                                <div className="main-menu-two__left">
                                    <div className="main-menu-two__logo">
                                        <Link to="/">
                                            <img src={navImg} alt="Logo" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="main-menu-two__right">
                                    <div className="main-menu-two__main-menu-box">
                                        <div
                                            className="mobile-nav__toggler"
                                            onClick={handleMobileMenu}
                                        >
                                            <i className="fa fa-bars"></i>
                                        </div>
                                        <ul className="main-menu__list">
                                            <MenuItems
                                                parentMenu={parentMenu}
                                                secondParentMenu={secondParentMenu}
                                                activeMenu={activeMenu}
                                            />
                                        </ul>
                                    </div>
                                    <div className="main-menu-two__search-btn-box">
                                        <div
                                            // className="main-menu-two__search search-toggler icon-search"
                                            onClick={handlePopup}
                                        ></div>
                                        <div className="main-menu-two__btn-box">
                                        <p className="pickOne">Need Help?
                                            <div className='pickTwo'>
                                                <Link to="tel:+91 80969 62555" >+91 80969 62555</Link>
                                            </div>
                                        </p> 
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                <div className={`stricky-header stricked-menu main-menu main-menu-two ${isVisible ? "stricky-fixed" : ""}`}>
                    <div className="sticky-header__content" />
                    <nav className="main-menu main-menu-two">
                        <div className="main-menu-two__wrapper">
                            <div className="container">
                                <div className="main-menu-two__wrapper-inner">
                                    <div className="main-menu-two__left">
                                        <div className="main-menu-two__logo">
                                            <Link to="/">
                                                <img src={navImg} alt="Logo" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="main-menu-two__right">
                                        <div className="main-menu-two__main-menu-box">
                                            <div
                                                className="mobile-nav__toggler"
                                                onClick={handleMobileMenu}
                                            >
                                                <i className="fa fa-bars"></i>
                                            </div>
                                            <ul className="main-menu__list">
                                                <MenuItems
                                                    parentMenu={parentMenu}
                                                    secondParentMenu={secondParentMenu}
                                                    activeMenu={activeMenu}
                                                />
                                            </ul>
                                        </div>
                                        <div className="main-menu-two__search-btn-box">
                                            {/* <div
                                                className="main-menu-two__search search-toggler icon-search"
                                                onClick={handlePopup}
                                            ></div> */}
                                            <div className="main-menu-two__btn-box">
                                        <p className="pickOne">Need Help?
                                            <div className='pickTwo'>
                                                <Link to="tel:+91 80969 62555" >+91 80969 62555</Link>
                                            </div>
                                        </p> 
                                        
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

                <MobileMenu handleMobileMenu={handleMobileMenu} />
            </header>
            <SearchPopup isPopup={isPopup} handlePopup={handlePopup} />
        </React.Fragment>
    );
}

export default HeaderStyleTwo;
